import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { DateTimeFormatterPipe } from '@trademe/tangram';

@Component({
    selector: 'tm-date',
    templateUrl: 'tm-date.component.html',
    styleUrls: ['tm-date-component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class TmDateComponent {
    randomId = Math.random().toString(36).substring(2);

    @Input() id = `tm-date-${this.randomId}`;
    @Input() name = `${this.id}-name`;
    @Input() label = 'Date';
    @Input() required = false;
    @Input() inputReadonly = false;
    @Input() disabled = false;

    @Input() showLabel = true;
    @Input() hideOptionalLabel = false;

    @Input() minDate: Date | null = null;
    @Input() maxDate: Date | null = null;
    @Input() validation: any;

    @Input() hasError: boolean | null = null;

    @Input() selectedDate: Date;
    @Output() dateChange = new EventEmitter<Date>();

    containerId = `tm-date-container-${this.randomId}`;

    constructor(private _dateTimeFormatterPipe: DateTimeFormatterPipe) {}

    public onDateChange(): void {
        this.dateChange.emit(this.selectedDate);
    }

    getRequired(): boolean {
        return this.validation?.validations?.required || this.required;
    }

    getValidation(): any {
        return {
            required: {
                message: `${
                    this.validation?.validations?.name || this.label
                } is required`
            },
            matDatepickerParse: {
                message: 'Invalid date format'
            },
            matDatepickerMin: {
                message: `${
                    this.validation?.validations?.name || this.label
                } cannot be in the past`
            },
            matDatepickerMax: {
                message: `${
                    this.validation?.validations?.name || this.label
                } cannot be beyond ${this._dateTimeFormatterPipe.transform(
                    this.maxDate,
                    { format: 'long' }
                )}`
            },
            ...this.validation?.errors
        };
    }
}
